// extracted by mini-css-extract-plugin
module.exports = {"loader":"CircleLoader_loader__1_q_j","load8":"CircleLoader_load8__186qj"};